import { Helpers, Utils } from '../../Core';
import { getCmsDeliveryApi as API } from '../../Apis';
import { mocksService } from './GetCmsAirTransportContract.mocks';
import dataFields from '../../Types/CmsAirTransportContract.json';
import {
  Article,
  FormattedContent,
} from '../../Types/CmsAirTransportContract.types';
import { AirTransportContractContent } from '../../Types/internals/CmsAirTransportContract.internals.types';

const prepareCall = async () => {
  const { cmsDeliveryIds } = Helpers.getConstants();
  const { AIR_TRANSPORT_CONTRACT } = cmsDeliveryIds as {
    [key: string]: string;
  };

  return await API.call.get({
    contentId: AIR_TRANSPORT_CONTRACT,
  });
};

const formatContent = (
  contentRaw: AirTransportContractContent,
): FormattedContent => {
  const { content } = contentRaw;
  const {
    title,
    'title-1': subtitle,
    firstParagraph,
    firstDefinition,
    firstSubtitle,
  } = content;
  const articles: Article[] = [];
  const textContent: FormattedContent['content']['textContent'] = [];
  const considerations: FormattedContent['content']['considerations'] = [];
  const termsOfUse: FormattedContent['content']['termsOfUse'] = [];

  Object.keys(content).forEach((key) => {
    const value = content[key as keyof AirTransportContractContent['content']];
    const upperKey = key.toUpperCase();
    if (upperKey.startsWith('CONSIDERATIONS')) {
      considerations.push(value);
    } else if (
      upperKey.startsWith('TEXTCONTENT') &&
      !upperKey.includes('ARTICLE')
    ) {
      textContent.push(value);
    } else if (
      upperKey.startsWith('ARTICLETITLE') ||
      upperKey.startsWith('ARTICLETEXTCONTENT')
    ) {
      let articleId = 0;
      if (
        !upperKey.match(
          /^(ARTICLETITLE|ARTICLETEXTCONTENT|ARTICLETEXTCONTENTDEF-\d+)$/,
        )
      ) {
        articleId = Number(key.match(/-\d+/)?.[0]?.slice(1) ?? '0');
      }
      const isTitle = upperKey.startsWith('ARTICLETITLE');

      if (!articles[articleId]) {
        articles[articleId] = {
          articleTitle: '',
          articleTextContent: [],
        };
      }

      if (isTitle) {
        articles[articleId].articleTitle = value;
      } else {
        articles[articleId].articleTextContent.push(value);
      }
    } else if (upperKey.startsWith('TERMSOFUSE')) {
      termsOfUse.push(value);
    }
  });

  return {
    id: contentRaw.id,
    content: {
      title,
      subtitle,
      firstParagraph,
      considerations,
      firstDefinition,
      firstSubtitle,
      textContent,
      articles,
      termsOfUse,
    },
  };
};

const handleSucessFinalResponseFunction = (
  result: AirTransportContractContent,
) => {
  return formatContent(result);
};

export const { machine, Docs } = Utils.genericMachine({
  invokeApiFunction: prepareCall,
  definitionsAPI: API.definitions,
  handleResponse: { handleSucessFinalResponseFunction },
  mocksService,
  dataFields,
});
